import { compose, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { isInvalid } from 'redux-form';
import withRouter from 'react-router/lib/withRouter';
import Actions from '../components/Actions';
import { withFormName } from '../../../common/hoc/withFormName';
import confirmModal from '../../../common/confirmModal';
import withNotifications from '../../../common/withNotifications';
import { getRoleIdType } from '../../../auth/selectors';
import { t } from '../../../../modules/infra/i18n';

export default compose(
  withFormName,
  withRouter,
  connect((state) => ({
    invalid: isInvalid('serviceDetails')(state),
    roleIdType: getRoleIdType(state),
  })),
  withNotifications,
  withProps((props) => ({
    isDeletable: !!props.deleteService,
    isAssignmentPageAvailable: props.roleIdType.type !== 'barber',
  })),
  withHandlers({
    handleDelete: (props) => async () => {
      if (!props.isDeletable) {
        return false;
      }

      const confirmed = await confirmModal({
        type: 'danger',
        title: t('services:form.delete_modal.title'),
        message: t('services:form.delete_modal.message'),
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteService().then(() => {
        props.router.replace(props.baseUrl);
        props.addNotification({
          level: 'success',
          message: t('services:form.delete_success_message'),
          title: t('common:success_title'),
        });
      });
    },
  })
)(Actions);
